import { render, staticRenderFns } from "./SendMailTemplate.vue?vue&type=template&id=549968c1&"
import script from "./SendMailTemplate.vue?vue&type=script&lang=js&"
export * from "./SendMailTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports